import React from 'react';
import classNames from 'classnames';
import { TooltipText } from 'utils/components/Tooltip/Tooltip';
import { BooleanKeys } from 'utils/types/BooleanKeys';
import { WidgetTimeSeriesLegend } from 'widgets/WidgetTimeSeriesLegend/WidgetTimeSeriesLegend';
import { IntraDayProfileWidgetLegends } from 'widgets/intraDayProfile/store/configuration/IntraDayProfileConfiguration';

interface IntraDayProfileLegendProps {
    alignDropdown?: 'left' | 'center' | 'right';
    className: string;
    containerLeft: number;
    label: string;
    hideSeriesPropertyName: BooleanKeys<IntraDayProfileWidgetLegends>;
    value?: string;
    suffix?: string;
    tooltip: TooltipText;
}

export default function IntraDayProfileLegend(
    props: IntraDayProfileLegendProps
) {
    const {
        alignDropdown,
        className,
        containerLeft,
        label,
        hideSeriesPropertyName,
        value,
        suffix,
        tooltip,
    } = props;

    return (
        <WidgetTimeSeriesLegend<IntraDayProfileWidgetLegends>
            alignDropdown={alignDropdown}
            className={classNames(className, 'IntraDayProfileLegend')}
            label={label}
            value={value}
            suffix={suffix}
            tooltip={tooltip}
            hideSeriesPropertyName={hideSeriesPropertyName}
            containerLeft={containerLeft}
        />
    );
}
